import './Home.css';
import '@fontsource/inter';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faMapMarkerAlt, faIdBadge, faHospital, faUsers, faComputer } from '@fortawesome/free-solid-svg-icons';
import Copyright from '../components/Copyright';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import { CiUser } from "react-icons/ci";
import { faBookOpen, faComments, faNewspaper, faFootball } from '@fortawesome/free-solid-svg-icons';
import Search from '../components/Search'; // Import the Search component
import { ToggleSlider } from 'react-toggle-slider';

const Home = () => {
  const navigate = useNavigate();

  const [isAccessible, setIsAccessible] = useState(false); // Toggle state for accessibility mode

  const handleCalendarClick = () => navigate('/calendar');
  const handleUserProfileClick = () => navigate('/user-profile');
  const handleStudentCard = () => navigate('/student-card');
  const handleCampusMap = () => navigate('/campus-map');
  const handleTechHelp = () => navigate('/tech-help');
  const handleCampusLife = () => navigate('/campus-life');
  const handleCampusBoard = () => navigate('/campus-board');
  const handleStudentMessages = () => navigate("/student-messaging");
  const handleCampusRec = () => navigate("/campus-rec");
  const handleStudentEvents = () => navigate("/student-events");
  const handleStudentNews = () => navigate("/news-feed");
  const handleHealth = () => navigate("/health-center");
  const handleLibrary = () => navigate("/cook-library");

  const toggleContrast = () => setIsAccessible(!isAccessible);
  const [active, setActive] = useState(false);

  return (
    <section
      className="home-container"
      style={{
        backgroundSize: "90%",
        backgroundRepeat: 'repeat',
        backgroundPosition: "left",
        filter: isAccessible ? "grayscale(75%) brightness(100%)" : "none", // Apply filter for accessibility
        transition: "filter 0.1s ease-in"
      }}
    >
      <CurrentTime />
      <DynamicIsland />
      <h1 style={{ color: "white", fontWeight: "bold", position: "sticky", zIndex: "1001"}}>Welcome, John Doe!</h1>
      <div className="home-header">
      <div className="contrast-slider">
  <ToggleSlider
    onToggle={(state) => {
      setActive(state); // Update the active state
      toggleContrast(state); // Handle the contrast toggling
    }}
    style={{
      background: "black",
      color: "white",
      borderRadius: "5px",
      padding: "5px 10px",
      cursor: "pointer",
      fontSize: "14px",
      width: "70px",
      height: "50px",
      marginRight: "auto"
    }}
  />
</div>

      <Search placeholder="Search for..." />

      <div className="user-profile">
        <button
          onClick={handleUserProfileClick}
          style={{ background: "none", border: "none", fontSize: "48px" }}
        >
          <CiUser className="user-icon" style={{ color: "white" }} />
        </button>
      </div>
      </div>
      <div className="options">
        {/* Button Containers */}
        <div className="button-container">
          <button onClick={handleCampusBoard} className="campus-board">
            <img src='img/campusboard.png' alt="CampusBoard" loading="eager"/>
          </button>
          <span className="button-title">CampusBoard</span>
        </div>
        <div className="button-container">
          <button onClick={handleCalendarClick} className="calendar">
            <FontAwesomeIcon icon={faCalendar} size="4x"/>
          </button>
          <span className="button-title" style={{fontSize: "13px"}}>Academic Calendar</span>
        </div>
        <div className="button-container">
          <button onClick={handleStudentCard}>
            <FontAwesomeIcon icon={faIdBadge} size="4x"/>
          </button>
          <span className="button-title">Student ID</span>
        </div>
        <div className="button-container">
          <button>
            <FontAwesomeIcon icon={faBookOpen} size="4x" />
          </button>
          <span className="button-title">Library</span>
        </div>
        <div className="button-container">
          <button onClick={handleCampusMap}>
            <FontAwesomeIcon icon={faMapMarkerAlt} size="4x"/>
          </button>
          <span className="button-title">Campus Map</span>
        </div>
        <div className="button-container">
          <button>
            <FontAwesomeIcon icon={faUsers} size="4x"/>
          </button>
          <span className="button-title">PeopleSoft</span>
        </div>
        <div className="button-container">
          <button onClick={handleHealth}>
            <FontAwesomeIcon icon={faHospital} size="4x" />
          </button>
          <span className="button-title">Health Services</span>
        </div>
        <div className="button-container">
          <button onClick={handleCampusLife}>
          <img src='img/campus-life.png' alt="Campus life"/>
          </button>
          <span className="button-title">Campus Life</span>
        </div>
        <div className="button-container">
          <button onClick={handleStudentMessages}>
          <FontAwesomeIcon icon={faComments} size="4x" />          </button>
          <span className="button-title" style={{fontSize:"13px"}}>Student Messaging</span>
        </div>
        <div className="button-container">
          <button onClick={handleCampusRec}>
          <img src='img/towson-tiger.png' alt="Campus rec"/>
          </button>
          <span className="button-title" style={{fontSize:"13px"}}>Campus Recreation</span>
        </div>
        <div className="button-container">
          <button onClick={handleStudentNews}>
          <FontAwesomeIcon icon={faNewspaper} size="4x" />          
          </button>
          <span className="button-title">TU News</span>
        </div>
        <div className="button-container">
          <button onClick={handleStudentEvents}>
          <img src='img/towson-tiger.png' alt="Campus events"/>
          </button>
          <span className="button-title">Events</span>
        </div>
        <div className="button-container">
          <button onClick={handleTechHelp}>
            <FontAwesomeIcon icon={faComputer} size="4x"/>
          </button>
          <span className="button-title">Tech Help</span>
        </div>
        <div className="button-container">
          <button>
            <FontAwesomeIcon icon={faFootball} size="4x"/>
          </button>
          <span className="button-title" style={{fontSize:"16px"}}>Gameday</span>
        </div>
        <div className="button-container">
          <button>
          <img className="microsoft-logo" src='img/microsoft-365.png' alt="Microsoft 365"/>
          </button>
          <span className="button-title" style={{fontSize:"16px"}}>Microsoft 365</span>
        </div>
      </div>

      <Copyright />
    </section>
  );
};

export default Home;
